import { render, staticRenderFns } from "./Bienvenida.vue?vue&type=template&id=463519c0&scoped=true"
import script from "./Bienvenida.vue?vue&type=script&lang=js"
export * from "./Bienvenida.vue?vue&type=script&lang=js"
import style0 from "./Bienvenida.vue?vue&type=style&index=0&id=463519c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463519c0",
  null
  
)

export default component.exports